<ms-header
    *ngIf="showBackgroundContainer"
    [titleIcon]="titleIcon"
    [backgroundContainerConfig]="backgroundContainerConfig"
    [globalLinkConfig]="globalLinkConfig"></ms-header>

<ms-ghost-loader *ngIf="isLoaderVisible"> </ms-ghost-loader>
<ms-scroll-adapter *ngIf="(promotionTiles?.length || tiles?.length) && !isLoaderVisible" [scrollSpeed]="scrollSpeed" [buttonSize]="36">
    <ul class="center" [ngClass]="getListCardClass()">
        <li
            class="marquee-card card crm-promo-card"
            *ngFor="let promotion of promotionTiles; trackBy: trackPromoBy; let promoIndex = index"
            [ngClass]="crmPromotionClass"
            [attr.data-index]="promoIndex">
            <ms-crm-promotion-banner
                [promotion]="promotion"
                [listIndex]="promoIndex"
                [trackingSource]="promotionTrackingSource"></ms-crm-promotion-banner>
        </li>
        <li
            class="marquee-card card"
            *ngFor="let tile of tiles; let index = index; trackBy: trackTile"
            [ngClass]="setClass(index)"
            [attr.data-index]="index">
            <ng-container *ngIf="!getType(tile); else tileTemplate">
                <ms-crm-promotion-banner
                    [promotion]="tile"
                    [listIndex]="tileIndex(index)"
                    [trackingSource]="promotionTrackingSource"></ms-crm-promotion-banner>
            </ng-container>
            <ng-template #tileTemplate>
                <ng-container [ngSwitch]="getType(tile)">
                    <ms-betbuilder-card
                        *ngSwitchCase="'BuildABet'"
                        [tile]="tile"
                        [page]="page"
                        [preventNavigation]="preventNavigation"
                        [trackingPosition]="tileIndex(index)"
                        (click)="track(tileIndex(index), tile)">
                    </ms-betbuilder-card>

                    <ng-container *ngSwitchCase="'Regular'">
                        <ms-promotion-badge *ngIf="promotedFixtureIdsMap[getEvent(tile)]"></ms-promotion-badge>
                        <ng-container [ngSwitch]="tilesWithFallbackMarketType[index].marketType">
                            <ms-correct-score-card
                                *ngSwitchCase="'CorrectScore'"
                                [tile]="tile"
                                [page]="page"
                                [preventNavigation]="preventNavigation"
                                [backgroundImage]="tile?.source?.imageUrl"
                                [trackingPosition]="tileIndex(index)"
                                (click)="track(tileIndex(index), tile)"
                                (correctScoreFallbacktoRegularTile)="triggerFallbackTile($event)">
                            </ms-correct-score-card>
                            <ms-correct-score-card
                                *ngSwitchCase="'DynamicCorrectScore'"
                                [tile]="tile"
                                [page]="page"
                                [preventNavigation]="preventNavigation"
                                [backgroundImage]="tile?.source?.imageUrl"
                                [trackingPosition]="tileIndex(index)"
                                (click)="track(tileIndex(index), tile)"
                                (correctScoreFallbacktoRegularTile)="triggerFallbackTile($event)">
                            </ms-correct-score-card>
                            <ms-six-pack-event
                                *ngSwitchCase="'SixPack'"
                                [tile]="tile"
                                [event]="tile.event"
                                [textColor]="tile?.source?.textColor"
                                [backgroundImage]="tile?.source?.imageUrl"
                                [trackingPosition]="tileIndex(index)"
                                (click)="track(tileIndex(index), tile)"
                                (sixPackFallbacktoRegularTile)="triggerFallbackTile($event)">
                            </ms-six-pack-event>
                            <ms-highlights-regular-card
                                *ngSwitchDefault
                                [tile]="tile"
                                [page]="page"
                                [trackingPosition]="tileIndex(index)"
                                [images]="getTileImages(tile)"
                                [preventNavigation]="preventNavigation"
                                (click)="track(tileIndex(index), tile)"
                                (regularToCorrectScoreFallbackTile)="triggerFallbackTile($event)">
                            </ms-highlights-regular-card>
                        </ng-container>
                    </ng-container>

                    <ms-highlights-special-card
                        *ngSwitchCase="'Special'"
                        [tile]="tile"
                        [page]="page"
                        [preventNavigation]="preventNavigation"
                        [trackingPosition]="tileIndex(index)"
                        (click)="track(tileIndex(index), tile)">
                    </ms-highlights-special-card>
                </ng-container>
            </ng-template>
        </li>
    </ul>
</ms-scroll-adapter>
